import { useEffect, useState } from 'react'

/** Facebook SDK domain; if this is blocked, login would fail anyway. */
const FACEBOOK_CHECK_URL = 'https://connect.facebook.net/en_US/sdk.js'
const CHECK_TIMEOUT_MS = 4000

/**
 * Returns whether Facebook is reachable from the client (e.g. not blocked in this region).
 * - null: check still in progress
 * - true: request to Facebook succeeded → show Facebook login
 * - false: request failed or timed out → hide Facebook login
 */
export function useFacebookReachable(): boolean | null {
  const [reachable, setReachable] = useState<boolean | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS)

    fetch(FACEBOOK_CHECK_URL, {
      method: 'GET',
      mode: 'no-cors',
      signal: controller.signal,
      cache: 'no-store',
    })
      .then(() => {
        setReachable(true)
      })
      .catch(() => {
        setReachable(false)
      })
      .finally(() => {
        clearTimeout(timeoutId)
      })

    return () => {
      clearTimeout(timeoutId)
      controller.abort()
    }
  }, [])

  return reachable
}
